export enum FieldComponentTypeEnum {
  Text = 'Text',
  Select = 'Select'
}
